import React from 'react';
import { shape, bool, instanceOf, func } from 'prop-types';
import DeButton from '../../shared/DeButton';
import { useSelector } from 'react-redux';
import SearchBox from './SearchBox';
import { _getCheckedDefination } from '../../../../util/deUtils';
import ContextMenuReport from './ContextMenuReport';

const CTHeader = ({
  definition,
  updateQueryParams,
  handleAction,
  internalAdmin,
  setView,
}) => {
  const impersonated = useSelector(
    state => state.login.loginResponse.data.impersonated
  );
  let isExportDisabled = true;
  let isSearchDisabled = true;
  const activeDefination = _getCheckedDefination(definition.data, 'isActive');
  if (
    (!definition.loading && definition.data.length > 0) ||
    definition.hasDefinition
  ) {
    isSearchDisabled = false;
    if (activeDefination.length > 0) {
      isExportDisabled = false;
    }
  }
  if (impersonated) {
    isExportDisabled = impersonated;
  }

  const _handleOnSearch = (searchValue, query) => {
    updateQueryParams(searchValue, query);
  };

  const _handleClick = actionType => {
    const selectedTarget = definition.data.find(item => item.isActive);
    if (selectedTarget) {
      handleAction(actionType, selectedTarget);
    }
  };
  const _handleViewReports = () => {
    setView('reports');
  };
  return (
    <div className="de--campaign--search--root">
      <div className="de--campaign--search">
        <SearchBox onChange={_handleOnSearch} disabled={isSearchDisabled} />
      </div>
      <div className="de--campaign--action">
        <DeButton
          plain
          label="LABEL"
          id="export"
          onClick={() => _handleClick('Label')}
          disabled={isExportDisabled}
        />
        <DeButton
          plain
          label="DESTINATIONS"
          id="distribute"
          onClick={() => _handleClick('Distribute')}
          disabled={isExportDisabled}
        />
        {internalAdmin && (
          <ContextMenuReport handleViewReports={_handleViewReports} />
        )}
      </div>
    </div>
  );
};

CTHeader.propTypes = {
  definition: shape({
    loading: bool,
    error: bool,
    data: instanceOf(Array),
  }),
  updateQueryParams: func,
  handleAction: func,
  internalAdmin: bool,
  setView: func,
};

CTHeader.defaultProps = {
  definition: {
    loading: true,
    error: false,
    data: [],
  },
  internalAdmin: false,
};

export default CTHeader;
